export function hasOwnNestedProperty(obj, propertyPath) {
  if (!obj || !propertyPath)
    return false;

  const properties = propertyPath.split('.');

  for (let i = 0; i < properties.length; i++) {
      const prop = properties[i];
      if (!obj || !obj.hasOwnProperty(prop)) {
          return false;
      } else {
          obj = obj[prop];
      }
  }

  return true;
}

export function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  while (0 !== currentIndex) {

    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

export function normalizeValue(value, min, max) {
  const normalizedValue =  (value - min) * (1 - 0) / (max - min) + 0;
  return normalizedValue > 1 ? 1 : normalizedValue;
}